//  ----------      START   IMPORT  BLOCK       ----------
//  Services
import APIService from '../Core/APIService';
//  Config
import API_ROUTES from '../../ConfigFiles/Routes/api_routes';
//  ----------      END   IMPORT  BLOCK       ----------

class UserProToPatientService extends APIService {

  /**
   * Transforms raw UI form data into the strict schema expected by the FastAPI backend.
   */
  _mapToSchema(data) {
    return {
      general_info: {
        sex: data.sex,
        height: Number(data.height) || 0,
        weight: Number(data.weight) || 0,
        marital_status: data.marital_status, // Send ID, backend maps it
        occupation: data.occupation || "",
        religion: data.religion,
        education: data.scholarship
      },
      fitness: data.fitness,
      substances: data.substances,
      diet: {
        ...data.diet,
        diet: data.diet.diet_type || 0
      },
      sexual_health: data.sexual_health
    };
  }

  async createProfileOnboarding(rawFormData) {
    try {
      const mappedData = this._mapToSchema(rawFormData);
      console.log("🚀 Payload ready for API:", mappedData);

      return await this.post(API_ROUTES.onboarding_pro_upgrade, mappedData);
    } catch (error) {
      console.error("Onboarding Service Error:", error);
      throw error;
    }
  }
}

const serviceInstance = new UserProToPatientService();
export default serviceInstance;
